module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/7-1a782ec702aacad0bd413323b8aaddfe.svg";